import UI from "./base/UI";
import Step from "./Step";
import Accordion from "./Accordion";

export default class StepAccordion extends UI{
    constructor(el, options){
        super('stepAccordion', el);

        this.accordion = new Accordion(el, options);
        this.step = new Step(el, options);
    }
   
    update(){
        this.accordion.update();
        this.step.update();
    }

    render(){
        this.accordion.render();
        this.step.render();
    }

    attachEvents(){
        this.accordion.attachEvents();
        this.step.attachEvents();
    }

    open(index){
        this.accordion.open(index);
    }

    close( index ){
        this.accordion.close(index);
        this.step.close(index);
    }

    detachEvents(){
        this.accordion.detachEvents();
        this.step.detachEvents();
    }

    destroy(){
        this.accordion.destroy();
        this.step.destroy();
    }

    a11yInit(){
        this.accordion.a11yInit();
        this.step.a11yInit();
    }

    a11yAriaExpand(){
        this.accordion.a11yAriaExpand();
    }
}